import React from 'react';
import { BaseTagsConfiguration } from '../Projects/ProjectsTagsConfiguration';
import { useContactsTags, useContactsTagsConfiguration } from './useContactsTagsConfiguration';
import { BaseTagsActivator, BaseTagsPicker, TagsPickersProps } from '../Projects/ProjectTagsPicker';

interface Props {
  
}


export const ContactsTagsConfiguration = (props: Props) => {
  const data = useContactsTagsConfiguration();

  return (
    <BaseTagsConfiguration data={data} />
  );
}


export const ContactsTagsActivator = (props: TagsPickersProps) => {
  const { tags } = useContactsTags();

  return (
    <BaseTagsActivator
      options={tags}
      {...props}
      />
  )
}

export const ContactTagsPicker = (props: TagsPickersProps) => {
  const config = useContactsTags();
  return (
    <BaseTagsPicker
      config={config}
      {...props}
      />
  )
}